import { Tabs, Tab, TabsProps, styled, css, TabProps } from '@mui/material'
import { TabsMenuStylesProps } from './TabsMenu.types'
import HeaderList from '../HeaderList/HeaderList'

export const TabsMenuWrapper = styled(Tabs, {
  shouldForwardProp: (prop) => !['buttonStyle'].includes(String(prop))
})<TabsProps & TabsMenuStylesProps>(
  ({ buttonStyle }) => css`
    min-height: 56px;
    padding: ${buttonStyle ? '14px 0' : '0 8px'};

    .MuiTabs-scroller {
      display: flex;
      padding: 0;
      margin: 0;

      .MuiTabs-flexContainer {
        z-index: 1;
        position: relative;
        display: flex;
      }
    }

    .MuiTabs-indicator {
      ${!!buttonStyle &&
      css`
        z-index: -1;
        top: 0;
        bottom: auto;
        height: 32px;
        border-radius: 6px;
      `}
    }

    .MuiTabScrollButton-root {
      &.Mui-disabled {
        opacity: 0.2;
      }

      &:first-of-type {
        margin-left: -8px;
      }

      &:last-of-type {
        margin-right: -8px;
      }
    }
  `
)
TabsMenuWrapper.defaultProps = {
  variant: 'scrollable',
  scrollButtons: true
}

export const TabItem = styled(Tab, {
  shouldForwardProp: (prop) =>
    !['buttonStyle', 'uppercase'].includes(String(prop))
})<TabsMenuStylesProps & TabProps>(
  ({ buttonStyle, theme, uppercase }) => css`
    min-width: 0;
    min-height: 32px;
    text-transform: ${uppercase ? 'uppercase' : 'capitalize'};
    font-size: 13px;
    padding: 0;
    margin: 0 8px;

    ${buttonStyle &&
    css`
      padding: 0 10px;
      margin: 0;
      transition: background-color 0.2s, color 0.2s;

      &.Mui-selected {
        color: ${theme.palette?.primary.contrastText};
        border-radius: 6px;
        font-weight: 500;
      }
    `}
  `
)

export const CustomHeaderList = styled(HeaderList)(
  () => css`
    padding: 4px 8px 0 8px;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    .HeadingText {
      font-size: 0.8rem;
    }
  `
)
